import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { EmptyStateComponent } from 'src/app/shared/empty-state/empty-state.component';

@Component({
  template: `<div class="flex__center flex__column not-found__container">
    <app-empty-state
      image="not-found"
      title="404 - Page not found"
      description="This page you are looking for does not exist or another error occured."
    />
    <a class="color--b-dark bold margin-top--one" routerLink="/">Go back to dashboard</a>
  </div>`,
  styles: `
    .not-found__container {
      height: 100%;
    }
  `,
  imports: [RouterLink, EmptyStateComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotFoundComponent {}
